<template>
  <div class="container" @click="flagOn">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <ControlEditor
          :locale="locale"
          :lang="langData.current"
          :spacetypeNames="spacetypeNames"
          :subtypeNames="subtypeNames"
          :controlInfo="controlInfo"
          :saveTimeStamp="saveTimeStamp"
          :moduleData="moduleData"
          :controlData="controlData"
          @updateModule="updateModule"
          @updateLabel="updateLabel"
          @init="init" />
      </div>
    </section>
    <div id="setContent">
      <SettingItem
        :locale="locale"
        :controlInfo="controlInfo"
        :subtypeNames="subtypeNames"
        :langs="langData"
        @save="save" />
    </div>
  </div>
</template>

<script>
import UTIL from '@/common/util'
import ControlEditor from '@/components/Control/ControlEditor'
import SettingItem from '@/components/Control/SettingItem'

export default {
  props: [
    'locale'
  ],
  components: {
    ControlEditor,
    SettingItem
  },
  computed: {
    langData () {
      return this.$store.getters['setting/getData'].lang
    }
  },
  created () {
    this.init()
  },
  watch: {
    '$route' (to, from, next) {
      this.init()
    }
  },
  data () {
    return {
      dirtyFlag: false,
      spacetypeNames: [],
      subtypeNames: [],
      spacetype: null,
      controlInfo: {
        spacetype: '',
        subtype: '',
        memo: '',
        viewtype: 'list',
        viewtypeAlign: 'left'
      },
      item: {
        property: {},
        siteid: this.$store.state.authentication.userInfo.siteid,
        spacetypeid: ''
      },
      modules: null,
      moduleData: [], // preview modules
      controlData: [], // control data tree
      saveTimeStamp: null // 타임스탬프를 watcher로 하여 변경될 때마다 세이브
    }
  },
  methods: {
    flagOn () {
      this.dirtyFlag = true
    },
    init () {
      const spacetype = this.$route.params.id || ''
      const subtype = this.$route.params.subtype || '0'
      const langValue = this.langData.langValue
      function getChildren (properties, type) {
        const index = Object.keys(properties)
        return index.map(x => {
          return {
            type: type,
            index: x,
            location: properties[x],
            label: UTIL.fillLangs(langValue, properties[x])
          }
        }).sort((a, b) => {
          return a.index < b.index ? -1 : a.index > b.index ? 1 : 0
        })
      }
      this.controlInfo.spacetype = spacetype
      this.controlInfo.subtype = subtype
      this.$store.commit('onLoading', true)
      this.$store.dispatch('control/getControl').then((res) => {
        if (res) {
          const spacetypeNames = res.map(x => x.spacetypeid)
          this.spacetypeNames = spacetypeNames
        }
        if (res && spacetype) {
          const subtypeNames = res.find(x => x.spacetypeid === spacetype).property.subtype || ['0']
          const property = res.find(x => x.spacetypeid === spacetype).property
          const types = Object.keys(property)
          let control = []
          for (let type of types) {
            if (!(type.includes('count') || type.includes('Mask') || type.includes('thing') || type.includes('tv') || type.includes('subtype'))) {
              const item = property[type]
              const data = {
                type: type,
                children: getChildren(item, type)
              }
              control.push(data)
            }
          }
          this.subtypeNames = subtypeNames
          this.controlData = control
          this.$store.dispatch('control/getSpaceType', { spacetype: spacetype, subtype: subtype }).then((res) => {
            if (res) {
              this.controlInfo = { ...this.controlInfo, ...res.info }
              this.moduleData = res.list
            }
            this.$store.commit('onLoading', false)
          })
          this.$store.commit('onLoading', false)
        } else {
          this.modules = null
          this.moduleData = []
          this.controlData = []
          this.$store.commit('onLoading', false)
        }
      })
    },
    updateModule (data) {
      this.modules = data
    },
    updateLabel (data) {
      this.modules.find(x => x.id === data.id).label = data.label
    },
    save () {
      this.dirtyFlag = false
      this.saveTimeStamp = new Date().getTime()
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer .innerColumn {
  padding: 0;
}
.label {
  font-size: 2em;
  font-weight: bold;
  color: $color-lgrey2;
}
.property {
  display: flex;
  span {
    position: relative;
    width: 48px;
    height: 48px;
    margin-right: 5px;
    text-indent: -9999px;
    border-radius: 100%;
    border: 1px solid $color-lgrey2;
    background-color: rgba($color-blue, 0.1);
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: 24px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      opacity: 0.5;
    }
    &[data-property="light"]:before {
      background-image: url('~@/assets/img/ico_light.png');
    }
    &[data-property="lightMask"]:before {
      background-image: url('~@/assets/img/ico_light.png');
    }
    &[data-property="tv"]:before {
      background-image: url('~@/assets/img/ico_tv.png');
    }
    &[data-property="fcu"]:before {
      background-image: url('~@/assets/img/ico_fcu.png');
    }
    &[data-property="curtain"]:before {
      background-image: url('~@/assets/img/ico_curtain.png');
    }

  }
}
</style>
